import contactDetails from './avg/contact-details';
import company from './avg/company';
import corporation from './avg/corporation';
import operationalArea from './avg/operational-area';
import shiftDay from './avg/shift-day';
import shiftPositions from './avg/shift-positions';
import shiftTemplate from './avg/shift-template';
import suppliers from './avg/suppliers';
import teams from './avg/teams';
import userActivityLog from './avg/user-activity-log';
import plannedValues from './avg/planned-values';
import metrics from './avg/metrics';
import RMVA from './avg/RMVA';
import TRAS from './avg/TRAS';
import monthlyValues from './avg/monthly-values';
import calendar from './avg/calendar';
import logBook from './avg/log-book';
import fabricData from './avg/fabric-data';
import year from './avg/year';
import recalculation from './avg/recalculation';
import energieWate from './avg/energie-wate';

import settings from './common/settings';
import auth from './common/auth';
import qrManagement from './common/qr-management';
import translate from './common/translate';
import time from './common/time';
import content from './common/content';
import sticker from './common/sticker';
import commonCompany from './common/company';
import report from './common/report';
import dynamicData from './common/dynamic-data';

import projects from './one/projects';
import projectMilestones from './one/project-milestones';
import milestoneGroup from './one/milestone-group';

import template from './tickets/template';
import ticket from './tickets/ticket';

import caseLists from './reports/case-lists';

import viewPermissions from './view/permissions';
import viewStructure from './view/structure';

import plantInput from './gmva/plantInput';
import coverSheet from './gmva/coverSheet';
import cummulation from './gmva/cummulationDailyQuantity';
import deckblatt from './gmva/deckblatt';

export default {
  commonCompany,
  calendar,
  logBook,
  plannedValues,
  contactDetails,
  company,
  corporation,
  operationalArea,
  shiftDay,
  shiftPositions,
  shiftTemplate,
  suppliers,
  teams,
  userActivityLog,
  settings,
  auth,
  qrManagement,
  metrics,
  RMVA,
  TRAS,
  translate,
  projects,
  projectMilestones,
  monthlyValues,
  time,
  milestoneGroup,
  fabricData,
  content,
  template,
  ticket,
  recalculation,
  year,
  report,
  energieWate,
  sticker,
  caseLists,
  dynamicData,
  viewPermissions,
  viewStructure,
  plantInput,
  coverSheet,
  cummulation,
  deckblatt,
};
